import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import { DataDisplayTypeSwitcher } from '~/components/features/DataDisplayTypeSwitcher'
import { useFormField } from '~/hooks/useFormField'

import { type InputValues } from '../utils'

export const DataDisplayTypeInput = () => {
  const { t } = useTranslation()
  const { control } = useFormContext<InputValues>()
  const dataDisplayTypeField = useFormField(control, 'dataDisplayType')

  return (
    <LabelingContainer label={t('switch_view')}>
      <DataDisplayTypeSwitcher
        value={dataDisplayTypeField.value}
        onChange={dataDisplayTypeField.onChange}
      />
    </LabelingContainer>
  )
}
